<template>
  <!-- 副导航栏 -->
  <div
    class="little-nav flex"
    :style="{ color: fontColor }"
    v-if="
      !(
        $route.path == '/forum/about/character' ||
        $route.path == '/forum/news/detail'
      )
    "
  >
    <div class="left-nav">
      <div class="scroll" ref="scroll">
        <div class="scro">
          <template v-for="(item, index) in navlist">
            <div
              v-if="goWay == 'name'"
              :key="index"
              @click="clickItem(index, item.path)"
              ref="navItem"
              @mouseenter="enter(index)"
              :class="[
                copyright == 'forum'
                  ? ['forum-nav-item', current == index ? 'forum-active' : '']
                  : [
                      'science-nav-item',
                      current == index ? 'science-active' : '',
                    ],
              ]"
            >
              {{ item.text }}
              <b-icon
                class="arrow"
                v-if="item.sub"
                icon="chevron-down"
              ></b-icon>
              <ul
                v-if="item.sub"
                class="nav-dropdown"
                :style="{ left: leftDistance + 'px' }"
              >
                <li
                  class="dropItem"
                  v-for="(subItem, ind) in item.sub"
                  @click.stop="clickSubItem(subItem.path)"
                  :key="ind"
                >
                  {{ subItem.text }}
                </li>
              </ul>
            </div>
            <div
              v-if="goWay == 'index'"
              :key="index"
              @click="clickItem(index, item.path, item.SecId)"
              ref="navItem"
              @mouseenter="enter(index)"
            >
              <span
                :class="[
                  copyright == 'forum'
                    ? ['forum-nav-item', current == index ? 'forum-active' : '']
                    : [
                        'science-nav-item',
                        current == index ? 'science-active' : '',
                      ],
                ]"
                >{{ item.text }}</span
              >
              <b-icon
                class="arrow"
                v-if="item.sub"
                icon="chevron-down"
              ></b-icon>
              <ul
                v-if="item.sub"
                class="nav-dropdown"
                :style="{ left: leftDistance + 'px' }"
              >
                <li
                  class="dropItem"
                  v-for="(subItem, ind) in item.sub"
                  @click.stop="clickSubItem(1)"
                  :key="ind"
                >
                  {{ subItem.text }}
                </li>
              </ul>
            </div>
          </template>
          <slot name="right-nav"></slot>
        </div>
      </div>
    </div>
    <!-- <div class="right-nav"> -->
    <!-- 右侧插槽 -->
    <!-- </div> -->
  </div>
</template>
<script>
export default {
  props: {
    fontColor: {
      type: String,
      default: "#666666",
    },
    goWay: {
      type: String, // 默认为'index' 通过index控制 ||  值'name'：表示通过路由的name来高亮导航
      default: "index",
    },
    navlist: Array,
    copyright: {
      //默认主题science || 论坛主题设置copyright='forum'
      type: String,
      default: () => "science",
    },
  },
  data() {
    return {
      leftDistance: 0,
      show: false,
      current: "",
    };
  },
  watch: {
    goWay(val) {},
    $route: {
      handler(to) {
        this.current = to.query.index;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    clickItem(index, path, SecId) {
      this.$emit("changeCurrent", index, path, SecId);
    },
    enter(index) {
      this.leftDistance =
        this.$refs.navItem[index].getBoundingClientRect().left -
        this.$refs.scroll.getBoundingClientRect().left; // this.current = index
    },
    clickSubItem(path) {
      this.$emit("subClick", path);
    },
  },
};
</script>
<style lang="scss" scoped>
.little-nav {
  position: relative;
  display: flex;
  justify-content: space-between;
  height: 4rem;
  line-height: 4rem;
  border-bottom: 0.1rem solid #eee;
  // margin: 2rem 1rem 0rem 1rem !important;

  .left-nav {
    flex: 3;
    // overflow: hidden;
    height: 6rem;
    position: relative;

    .right {
      display: flex;
      flex: 1;
      justify-content: flex-end;
    }

    .forum-nav-item {
      align-items: center;
    }

    .scroll {
      display: flex;
      justify-content: space-between;
    }

    .scro {
      display: flex;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      // height: 4rem;

      .science-nav-item,
      .forum-nav-item {
        cursor: pointer;
        flex-direction: column;
        width: max-content;
        display: flex;
        padding: 0rem 1.2rem 0rem 1.2rem;
        height: 4rem;
        font-size: 0.9rem;

        .arrow {
          position: relative;
          top: -17px;
          color: $science-theme-color;
          font-size: 0.8rem;
        }
      }

      .science-active {
        color: #c8a063;
        border-bottom: 0.1rem solid #c8a063;
      }

      .forum-active {
        color: $forum-theme-blue;
        border-bottom: 0.1rem solid $forum-theme-blue;
      }

      .forum-nav-item:hover,
      .forum-nav-item:focus {
        .nav-dropdown {
          display: block;
        }
      }

      .right {
        .nav-dropdown {
          height: 13rem;
          overflow-y: auto;
        }
      }

      .nav-dropdown {
        position: absolute;
        display: none;
        color: #666666;
        top: 4rem;
        line-height: 2.2rem;
        min-width: 8rem;
        background: #f2f2f2;
        text-align: center;
        z-index: 99;
        padding: 1rem;
        // height: 13rem;
        overflow-y: auto;

        .dropItem:hover {
          color: $forum-theme-blue;
        }

        .dropItem {
          padding: 0.2rem 0.5rem;
        }
      }

      .show {
        display: block;
      }
    }
  }
}

@media (min-width: 992px) {
  .forum-nav-item {
    font-size: 1rem !important;
  }
  .little-nav {
    margin-top: 2.7rem;
  }
  .right {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    position: absolute;
    right: 0px;
    // font-size: 1.5rem;
    color: black;

    .drop-down {
      height: 13rem;
      overflow-y: auto;
    }
  }

  .arrow {
    margin-left: 1rem;
    font-size: 0.9rem;
    left: -8px;
    font-weight: 900;
  }
}

@media (max-width: 768px) {
  .left-nav{
    height: 7rem;
    max-width: 24rem;
    // margin: 1rem;
  }
  .little-nav {
    margin: 0.5rem 1rem 1rem 1rem;
  }
  .drop-down {
    height: 13rem;
    overflow-y: auto;
  }
}
</style>